function getDefaultState() {
  return {
    isMobile: false
  }
}
export default {
  namespaced: true,
  state: {
    isMobile: false
  },
  getters: {
    isMobile(state) {
      return state.isMobile
    }
  },
  mutations: {
    setIsMobile(state, value) {
      state.isMobile = value
    },
    clearState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    setIsMobile({ commit }, value) {
      commit('setIsMobile', value)
    },
    clearState({ commit }) {
      commit('clearState')
    }
  }
}
